import MarketingPolicyAgreeModal from '@components/events/common/modal/marketingPolicyAgreeModal';
import MarketingPolicyCompleteModal from '@components/events/common/modal/marketingPolicyCompleteModal';
import classnames from 'classnames/bind';
import styles from './modal.module.scss';
const cx = classnames.bind(styles);

interface EventMailProfileModalsProps {
  isVisible: (state: string) => boolean;
  openModal: (state: string) => void;
  closeModal: () => void;
}

const EventMailProfileModals = ({ openModal, closeModal, isVisible }: EventMailProfileModalsProps) => {
  return (
    <>
      <MarketingPolicyAgreeModal
        visible={isVisible('MARKETING_POLICY_AGREE')}
        onClose={closeModal}
        onOpenMarketingPolicyComplete={() => openModal('MARKETING_POLICY_COMPLETE')}
      />
      <MarketingPolicyCompleteModal
        visible={isVisible('MARKETING_POLICY_COMPLETE')}
        onClose={closeModal}
        btnName="합격자 프로필 다운로드"
      />
    </>
  );
};

export default EventMailProfileModals;
